import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Button from "../../../../components/button/Button";
import ImagesDropdown from "../../../../components/inputs/imagesDropdown/ImagesDropdown";
import TextInput from "../../../../components/inputs/textInput/TextInput";
import TimeInput from "../../../../components/inputs/timeInput/TimeInput";
import Loader from "../../../../components/loader/Loader";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { showConfirmationModal } from "../../../../features/confirmationModal/ConfirmationModalSlice";
import { fetchRegionImages } from "../../../../features/images/regionImages/regionImagesSlice";
import { convertTimeStringToUTCWithToday } from "../../../../utils/timeZone";
import styles from "./editRegion.module.css";

const EditRegion = () => {
  const location = useLocation();

  const {
    regionId: fetchedRegionId,
    name: fetchedName,
    localizedPeakTimeStart: fetchedPeakTimeStart,
    localizedPeakTimeEnd: fetchedPeakTimeEnd,
    image: fetchedImage,
  } = location.state;
  const { timeZone } = useSelector((state) => state.timeZone);

  const toTimeInputValue = (dateValue) => {
    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return "";
    }

    return `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
  };

  const [name, setName] = useState(fetchedName);
  const [startTime, setStartTime] = useState(toTimeInputValue(fetchedPeakTimeStart));
  const [endTime, setEndTime] = useState(toTimeInputValue(fetchedPeakTimeEnd));
  const [image, setImage] = useState(fetchedImage);

  const dispatch = useDispatch();
  const { list, fetchStatus } = useSelector((state) => state.regionImages);
  const { updateStatus } = useSelector((state) => state.regions);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchRegionImages());
    }
  }, [fetchStatus, dispatch]);

  const start = convertTimeStringToUTCWithToday(startTime, timeZone);
  const end = convertTimeStringToUTCWithToday(endTime, timeZone);

  const handleUpdateRegion = () => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متاكد من التعديل على المنطقة ؟",
        data: {
          regionId: fetchedRegionId,
          regionData: {
            name,
            peakTimeStart: start.toISOString(),
            peakTimeEnd: end.toISOString(),
            image: image._id,
          },
        },
        actionType: "updateRegion",
      })
    );
  };

  if (fetchStatus === "loading" || updateStatus === "loading") {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <SettingsPagesContainer
      title={`التعديل على المنطقة : ${fetchedName}`}
      displayContainerClassName={styles.formDisplay}
    >
      <div className={styles.formShell}>
        <div className={styles.inputWrapper}>
          <TextWrapper textStyle="textMid">اسم المنطقة</TextWrapper>
          <TextInput
            height="52px"
            width="100%"
            borderRadius="12px"
            placeHolder="اسم المنطقة"
            bgColor={"grey"}
            bordered={true}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className={styles.timeGrid}>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">نهاية وقت الذروة</TextWrapper>
            <TimeInput value={endTime} onChange={(e) => setEndTime(e)} />
          </div>
          <div className={styles.inputWrapper}>
            <TextWrapper textStyle="textMid">بداية وقت الذروة</TextWrapper>
            <TimeInput value={startTime} onChange={(e) => setStartTime(e)} />
          </div>
        </div>
        <div className={styles.inputWrapper}>
          <TextWrapper textStyle="textMid">صورة المنطقة</TextWrapper>
          <ImagesDropdown data={list} value={image} setValue={setImage} />
        </div>
        <div className={styles.createNewRegionBtnWrapper}>
          <Button
            size="bigSize"
            variant="blackVariant"
            functionallity={handleUpdateRegion}
          >
            <TextWrapper textStyle="textMid">التعديل على المنطقة</TextWrapper>
          </Button>
        </div>
      </div>
    </SettingsPagesContainer>
  );
};

export default EditRegion;
